
<div class="card mb-0" style="width: 700px;">
    <div class="card-body" style="padding: 36px 40px">
        <h3 class="card-title-ai">
            {{title}}
        </h3>
        <p class="card-info">
            <a [href]="bodyTextLink" target="_blank"> {{bodyText}}</a>
        </p>
        <div class="card-btn">
            <button
                class="btn btn-outline-primary"
                type="button"
                (click)="addOn()"
            >
                Add on for $19/mo
            </button>
            <!--<button
                class="btn btn-outline-success"
                type="button"
                (click)="upgradePlan()"
            >
                Upgrade plan
            </button>-->
            <button
                class="btn btn-outline-secondary"
                type="button"
                (click)="cancel()"
            >
                No thanks 
            </button>
        </div>
    </div>
</div>
